export default __webpack_public_path__ + "static/media/javaSpring.77ea48c0.svg";